class NewsSimple {
  /**
   * 资讯id
   */
  id = ''
  /**
   * 标题
   */
  title = ''
  /**
   * 发布时间
   */
  publishTime = new Date()
  /**
   * 资讯内容 分页精简
   */
  content = ''
}

export default NewsSimple
